import React, { SVGProps } from 'react';
import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

import { IconProps } from 'components/assets/Icons/Icons';

/* eslint-disable max-len */
const UsersShareIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 9.375H8V7.875C8 6.77043 7.10457 5.875 6 5.875H2C0.895431 5.875 0 6.77043 0 7.875V9.375Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.25 8.625H0.75V7.875C0.75 7.18464 1.30964 6.625 2 6.625H6C6.69036 6.625 7.25 7.18464 7.25 7.875V8.625ZM0 9.375V7.875C0 6.77043 0.895431 5.875 2 5.875H6C7.10457 5.875 8 6.77043 8 7.875V9.375H0Z"
            fill="#49565D"
        />
        <path
            d="M1.5 2.375H6.5V4.875C6.5 6.25571 5.38071 7.375 4 7.375V7.375C2.61929 7.375 1.5 6.25571 1.5 4.875V2.375Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.125 2H6.875V4.875C6.875 6.46282 5.58782 7.75 4 7.75C2.41218 7.75 1.125 6.46282 1.125 4.875V2ZM1.875 2.75V4.875C1.875 6.0486 2.82639 7 4 7C5.1736 7 6.125 6.0486 6.125 4.875V2.75H1.875Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.60128 0.375H1.88086C1.05243 0.375 0.380859 1.04657 0.380859 1.875V4.375C0.380859 4.92728 0.828574 5.375 1.38086 5.375H1.51342V2.78731H6.38866C7.05867 2.78731 7.60128 2.22304 7.60128 1.52786V0.375Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.00585938 1.875C0.00585938 0.839466 0.845328 0 1.88086 0H7.97628V1.52786C7.97628 2.41649 7.27918 3.16231 6.38866 3.16231H1.88842V5.75H1.38086C0.621467 5.75 0.00585938 5.13439 0.00585938 4.375V1.875ZM1.88086 0.75C1.25954 0.75 0.755859 1.25368 0.755859 1.875V4.375C0.755859 4.63421 0.913651 4.85656 1.13842 4.95124V2.41231H6.38866C6.83816 2.41231 7.22628 2.02959 7.22628 1.52786V0.75H1.88086Z"
            fill="#49565D"
        />
        <path
            d="M18 18H10V16.5C10 15.3954 10.8954 14.5 12 14.5H16C17.1046 14.5 18 15.3954 18 16.5V18Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.75 17.25H17.25V16.5C17.25 15.8096 16.6904 15.25 16 15.25H12C11.3096 15.25 10.75 15.8096 10.75 16.5V17.25ZM18 18V16.5C18 15.3954 17.1046 14.5 16 14.5H12C10.8954 14.5 10 15.3954 10 16.5V18H18Z"
            fill="#49565D"
        />
        <path
            d="M16.5 11H11.5V13.5C11.5 14.8807 12.6193 16 14 16V16C15.3807 16 16.5 14.8807 16.5 13.5V11Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.875 10.625H11.125V13.5C11.125 15.0878 12.4122 16.375 14 16.375C15.5878 16.375 16.875 15.0878 16.875 13.5V10.625ZM16.125 11.375V13.5C16.125 14.6736 15.1736 15.625 14 15.625C12.8264 15.625 11.875 14.6736 11.875 13.5V11.375H16.125Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3987 9H16.1191C16.9476 9 17.6191 9.67157 17.6191 10.5V13C17.6191 13.5523 17.1714 14 16.6191 14H16.4866V11.4123H11.6113C10.9413 11.4123 10.3987 10.848 10.3987 10.1529V9Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9941 10.5C17.9941 9.46447 17.1547 8.625 16.1191 8.625H10.0237V10.1529C10.0237 11.0415 10.7208 11.7873 11.6113 11.7873H16.1116V14.375H16.6191C17.3785 14.375 17.9941 13.7594 17.9941 13V10.5ZM16.1191 9.375C16.7405 9.375 17.2441 9.87868 17.2441 10.5V13C17.2441 13.2592 17.0863 13.4816 16.8616 13.5762V11.0373H11.6113C11.1618 11.0373 10.7737 10.6546 10.7737 10.1529V9.375H16.1191Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2502 2.20156L12.41 1.161L11.8603 0.592773L10.2629 2.02582L10.2104 2.07721C9.91314 2.3953 9.93176 2.88243 10.2605 3.18432L11.8126 4.60952L12.3692 4.04749L11.2301 3.00156H14.3944C14.7175 3.00156 14.9793 3.26342 14.9793 3.58643V6.69308H15.7793V3.58643C15.7793 2.82159 15.1593 2.20156 14.3944 2.20156H11.2502Z"
            fill="#49565D"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.74985 15.6998L5.58995 16.7404L6.13971 17.3086L7.73709 15.8755L7.78957 15.8242C8.08686 15.5061 8.06824 15.0189 7.73947 14.717L6.18742 13.2918L5.63084 13.8539L6.76986 14.8998L3.60556 14.8998C3.28255 14.8998 3.0207 14.6379 3.0207 14.3149L3.0207 11.2083L2.2207 11.2083L2.2207 14.3149C2.2207 15.0798 2.84072 15.6998 3.60556 15.6998L6.74985 15.6998Z"
            fill="#49565D"
        />
    </svg>
);

export const UsersShareIcon = (props: IconProps) => (
    <Icon component={UsersShareIconSvg} {...props} />
);
